import * as React from 'react';

export const Logo = () => <img alt="GoBuild! Quantity & Check" width={130} src="logo.svg" />;
